import { AxiosRequestConfig } from "axios";
import qs from "qs";
import { endpoints } from "../../../config/endpoints";
import { axiosPrivateFetch } from "../../../services/fetch-service";
import { ApiResponse } from "../../../types";
import makeExcelReportFile from "../../../utils/make-report-file";

type IGetMembers = { page: number; rows: number; search?: string; filters: object };

const getMembers = async ({ page, rows, search, filters }: IGetMembers) => {
   const filterString = qs.stringify(filters, { arrayFormat: "repeat" });

   return axiosPrivateFetch.get(endpoints.members, { params: { page, rows, search, filter: filterString } });
};

const getAllMembers = async () => {
   return axiosPrivateFetch.get(`${endpoints.members}/all`);
};

async function getMember(id: string) {
   return axiosPrivateFetch.get(`${endpoints.members}/${id}`);
}

const submitMemberMaintenance = async ({ member, editOrCreate }) => {
   const options: AxiosRequestConfig =
      editOrCreate === "edit"
         ? {
              method: "PUT",
           }
         : { method: "POST" };
   options.data = member;

   const url = editOrCreate === "edit" ? `${endpoints.members}/${member.id}` : endpoints.members;

   return axiosPrivateFetch(url, options);
};

const downloadMembers = async () => {
   const result = (await axiosPrivateFetch.get(`${endpoints.membersReport}`)) as unknown as ApiResponse;
   return makeExcelReportFile({
      data: result.data,
      headers: result.reportHeaders,
      reportName: "Members_report",
   });
};

const getMembershipLevels = async () => {
   return axiosPrivateFetch.get(endpoints.members + "/groups");
};

const memberService = { getMembers, getAllMembers, getMember, submitMemberMaintenance, downloadMembers, getMembershipLevels };

export default memberService;
